module.exports = __webpack_public_path__ + "static/media/app-mockup.5c1167bb.png";